const UserProfileDropdownComponent = {
    templateUrl: '/userProfileButton/userProfileDropdown/userProfileDropdown.tpl.html',
    controller: 'userProfileDropdownController',
    bindings: {
        menuItems: '<'
    }
};

angular.module('gw-um-header')
    .component('uiUserProfileDropdown', UserProfileDropdownComponent);
